import { Layout } from 'antd';
import { useGetMenuMaster, handlerDrawerOpen } from 'api/menu';
import DrawerHeader from './DrawerHeader';
import DrawerContent from './DrawerContent';
import { DRAWER_WIDTH, MINI_DRAWER_WIDTH } from 'config';

const { Sider } = Layout;

export default function MainDrawer() {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster?.isDashboardDrawerOpened;

  return (
    <Sider
      theme="dark"
      collapsible
      collapsed={!drawerOpen}
      onCollapse={(collapsed) => handlerDrawerOpen(!collapsed)}
      width={DRAWER_WIDTH}
      collapsedWidth={MINI_DRAWER_WIDTH}
      trigger={null}
      className="border-r border-gray-100 overflow-auto sticky top-0 left-0 h-screen"
    >
      <DrawerHeader open={drawerOpen} />
      <DrawerContent />
    </Sider>
  );
}
